export const DISCORD_GUILD_HREF = `https://discord.com/channels/${process.env.REACT_APP_DISCORD_GUILD_ID}`;
